import { Dispatch, SetStateAction } from "react";
// components
import ReminderFields from "../reminder-fields/ReminderFields";
import BehaviorFields from "../behavior-fields";
import DiagnosisFields from "../diagnosis-fields";
import GoalFields from "../goal-fields";
// styles
import styles from "./styles.module.scss";

type Props = {
  readOnly?: boolean;
  code: ICDCode & { id: string; [key: string]: any };
  value: AdvancedTreatmentPlan;
  setValue?: Dispatch<SetStateAction<AdvancedTreatmentPlan>>;
};

const AdvancedPlanFields = ({ code, value, readOnly = false }: Props) => (
  <>
    <DiagnosisFields
      className={styles["advanced-plan-fields__block"]}
      readOnly={readOnly}
      code={code}
      value={value}
    />

    <BehaviorFields
      className={styles["advanced-plan-fields__block"]}
      readOnly={readOnly}
      value={value}
    />

    {value.goals && (
      <GoalFields
        className={styles["advanced-plan-fields__block"]}
        readOnly={readOnly}
        value={value}
      />
    )}

    <ReminderFields
      className={styles["advanced-plan-fields__block"]}
      readOnly={readOnly}
      value={value}
    />
  </>
);

export default AdvancedPlanFields;
